import {Injectable} from '@angular/core';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../shared';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { GenericDocContainerModel, GenericDocPgwTxnContainerModel, CpCommercePgwGenerateRefNoRequestModel} from '../../../../../models';

@Injectable({providedIn: 'root'})

export class CpCommerceInternalReceiptVoucherService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cp-commerce/internal-receipt-vouchers';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cp-commerce/internal-receipt-vouchers';
    this.httpClient = http;
  }

  generatePaymentReferenceNumber(request: CpCommercePgwGenerateRefNoRequestModel, apiVisa: ApiVisa) : Observable<BasicApiResponseModel<GenericDocPgwTxnContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/generate-payment-reference';
    return this.httpClient.post<BasicApiResponseModel<GenericDocPgwTxnContainerModel>>(
      url,
      request,
      this.getHttpHeader(apiVisa)
    );
  }
}
